import { TAxiosResponse } from './api';
import { LoginFormField, VerificationEmailFormField } from '../form/auth';

export enum UserRoleType {
  PROFESSOR = 'PROFESSOR',
  STUDENT = 'STUDENT',
}

export type TLoginParams = {
  [LoginFormField.UserRole]: UserRoleType;
  [LoginFormField.LoginId]: string;
  [LoginFormField.Password]: string;
};

export type TLoginResponse = {
  userId: number;
  userName: string;
  userRole: UserRoleType;
  accessToken: string;
  isAgreeTos: boolean;
  isFirstSetPw: boolean;
  pwChangeDateOver: number;
};

export enum TermsType {
  TermsCheckAll = 'termsCheckAll',
  PrivatePolicy = 'privatePolicy',
  TermsOfUse = 'termsOfUse',
}

export type TTerms = {
  [TermsType.TermsCheckAll]: string[];
  [TermsType.PrivatePolicy]: string;
  [TermsType.TermsOfUse]: string;
};

export type TResetPassword = {
  resetPassword: string | undefined;
  verifyPassword: string | undefined;
};

export type TSendVerificationEmailParams = {
  [VerificationEmailFormField.UserRole]: UserRoleType;
  [VerificationEmailFormField.Name]: string;
  [VerificationEmailFormField.LoginId]: string;
};

export type TCheckVerificationNumberParams = {
  [VerificationEmailFormField.Name]: string;
  [VerificationEmailFormField.LoginId]: string;
  [VerificationEmailFormField.UserRole]: UserRoleType;
  [VerificationEmailFormField.VerificationNum]: string;
};

export type TFindPasswordUserInfo = {
  userRole: UserRoleType | null;
  loginId: string | null;
};

export type TPasswordChange = {
  newPassword: string;
  newPasswordCheck: string;
};

export type TPasswordChangeByTokenParams = {
  newPassword: string;
  newPasswordCheck: string;
};

export type TPasswordChangeByLoginIdParams = {
  loginId: string;
  userRole: UserRoleType;
  newPassword: string;
  newPasswordCheck: string;
};

export type TIsLogin = {
  isLogin: boolean;
};

export type TAccessTokenReissueResponse = TAxiosResponse<string>;
